export const MAIL_SEND_QUEUE = 'mail-send';
export const NOTIFICATION_DISPATCH_QUEUE = 'notification-dispatch';
export const NOTIFICATION_DIGEST_QUEUE = 'notification-digest';

export const MISSED_EMAIL_DELAY_MS = 15 * 60 * 1000;

export type NotificationEmailMode =
  | 'off'
  | 'missed_only'
  | 'immediate'
  | 'daily_digest'
  | 'weekly_digest';

export type NotificationDeliveryPreset =
  | 'recommended'
  | 'in_app_only'
  | 'all_email'
  | 'custom';

export type NotificationCategoryKey =
  | 'messages'
  | 'mentions'
  | 'comments'
  | 'social'
  | 'creators'
  | 'communities'
  | 'platform'
  | 'account';

export type NotificationSocialGranular = {
  likes?: boolean;
  follows?: boolean;
  reposts?: boolean;
  saves?: boolean;
  likesPush?: boolean;
  followsPush?: boolean;
  repostsPush?: boolean;
  savesPush?: boolean;
};

export type NotificationCategoryPrefs = {
  inApp: boolean;
  email: NotificationEmailMode;
  push?: boolean;
  /** Per-type in-app overrides for the social category. */
  granular?: NotificationSocialGranular;
};

export type NotificationDigestPrefs = {
  enabled: boolean;
  frequency: 'daily' | 'weekly';
  hourUtc: number;
};

export type NotificationPrefsV2 = {
  version: 2;
  preset: NotificationDeliveryPreset;
  digest: NotificationDigestPrefs;
  categories: Record<NotificationCategoryKey, NotificationCategoryPrefs>;
};

export type MailSendJob = {
  deliveryId: string;
  userId: string;
  templateKey: string;
  toEmail: string;
  subject: string;
  html: string;
  text: string;
  idempotencyKey: string;
};

export const PLATFORM_EMAIL_SEND_QUEUE = 'platform-email-send';
export const MARKETING_CAMPAIGN_SEND_QUEUE = 'marketing-campaign-send';
/** Legacy Bull queue name retained for in-flight Circle email jobs during queue migration. */
export const LEGACY_COMMUNITY_EMAIL_SEND_QUEUE = 'community-email-send';
/** @deprecated Use MARKETING_CAMPAIGN_SEND_QUEUE. */
export const COMMUNITY_EMAIL_SEND_QUEUE = LEGACY_COMMUNITY_EMAIL_SEND_QUEUE;

export type PlatformEmailSendJob = {
  sendId: string;
  templateKey: string;
  variables: Record<string, unknown>;
  userIds: string[];
  contentOverride?: {
    subject: string;
    htmlBody: string;
    textBody: string;
  };
};

export type MarketingCampaignSendJob = {
  campaignId: string;
  audienceScope: string;
  communityId: string;
  templateKey: string;
  variables: Record<string, unknown>;
  userIds: string[];
  /** `fan-out` collects members and queues chunk jobs; `chunk` processes `userIds`. */
  mode?: 'fan-out' | 'chunk';
  chunkIndex?: number;
  totalChunks?: number;
};

/** @deprecated Use MarketingCampaignSendJob. */
export type CommunityEmailSendJob = MarketingCampaignSendJob;

export type NotificationSideEffectsJob = {
  notificationId: string;
  userId: string;
  type: string;
  payload: Record<string, unknown>;
};

export type NotificationDigestJob = {
  userId: string;
  frequency: 'daily' | 'weekly';
};

/** BullMQ custom job IDs cannot contain `:`. */
export function toBullJobId(idempotencyKey: string) {
  return idempotencyKey.replace(/:/g, '__');
}
